import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import { mapValues } from 'lodash'
import { InviteAnotherHomeowner } from 'src/constants/trackingEvents'
import { sendInvite } from 'src/actions/invite'
import { dispatchEvent } from 'src/helpers/tagManager'
import {
  FIRST_NAME,
  LAST_NAME,
  EMAIL
} from 'src/Components/shared/FormField/names'

const fieldMap = {
  firstName: FIRST_NAME,
  lastName: LAST_NAME,
  email: EMAIL
}

const ShareFormContainer = compose(
  connect(
    state => ({
      loading: state.invite.loading
    }),
    dispatch => ({
      onSubmit: e => {
        e.preventDefault()
        dispatchEvent(InviteAnotherHomeowner)
        const data = mapValues(fieldMap, k => e.target.elements[k].value)
        dispatch(sendInvite(data))
      }
    })
  ),
  injectIntl
)

export default ShareFormContainer
